import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ExpansionPanelComp from '../../common/ExpansionPanelComp';
import DatiPremioCapitaleAssicurato from './sezione/DatiPremioCapitaleAssicurato';

const styles = theme => ({
  root: {
    width: '100%',
  },
});
			
function PremioCapitaleAssicuratoPanel(props) {
	
  const { classes, isValida } = props;
  return (
    <div className={classes.root}> 
      <ExpansionPanelComp titolo={'premioCapitaleAssicurato'} componente={DatiPremioCapitaleAssicurato} isValida={isValida} /> 
    </div>
  );
}

PremioCapitaleAssicuratoPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PremioCapitaleAssicuratoPanel);
